import { ConnectedSquareIcon } from '@commercetools-uikit/icons';
import addonComponents from './addon-components';
import {
  CardBannerApiSvgIcon as CardBannerApiIcon,
  CardBannerDefaultSvgIcon as CardBannerDefaultIcon,
  CardBannerMcSvgIcon as CardBannerMcIcon,
  CardBannerOptional1SvgIcon as CardBannerOptional1Icon,
  CardBannerOptional2SvgIcon as CardBannerOptional2Icon,
  CardBannerOssSvgIcon as CardBannerOssIcon,
} from '../../../icons';

export default {
  ...addonComponents,
  DummyIcon: ConnectedSquareIcon,
  CardBannerApiIcon,
  CardBannerDefaultIcon,
  CardBannerMcIcon,
  CardBannerOptional1Icon,
  CardBannerOptional2Icon,
  CardBannerOssIcon,
};
